import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Box, Button, Grid2 } from '@mui/material';
import { TextInput } from '@utriper/core-ui';
import Title from 'modules/Pricing/components/Title';
import { Container, Label } from '../../styles';
import { validateRequiredString } from '@utriper/core';

const AddIncludesOptionForm = ({ onAddOption = () => {}, onClose = () => {}, maxLength = 128, placeholder = 'Ej: Seguro de viaje' }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`add_includes_option_form.${key}`);
    const handleSubmit = (values) => {
        onAddOption(values);
        onClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!validateRequiredString(values.newOption, maxLength)) {
            errors.newOption = t('common_form.required');
        }

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validateForm}
            render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit} noValidate style={{ width: '100%', marginTop: '16px' }}>
                    <Box component="section">
                        <Title title={translate('title')} description={translate('description')} />

                        {/* Form */}
                        <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                            {/* New Option */}
                            <Container>
                                <Label>{translate('new_option')}</Label>
                                <Field
                                    name="newOption"
                                    component={TextInput}
                                    placeholder={placeholder}
                                    slotProps={{
                                        input: {
                                            inputProps: {
                                                maxLength: maxLength,
                                            },
                                        },
                                    }}
                                />
                            </Container>
                        </Grid2>

                        <Grid2 container justifyContent="flex-end" alignItems="center" gap="16px" mt="32px" flexWrap="nowrap">
                            <Button
                                sx={{
                                    border: '1px solid #13131340',
                                    color: '#131313',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    py: '8px',
                                }}
                                variant="outlined"
                                onClick={(e) => {
                                    form.reset(e);
                                    onClose();
                                }}
                            >
                                {t('common.cancel')}
                            </Button>
                            <Button
                                sx={{
                                    backgroundColor: 'var(--color-utriper-blue)',
                                    color: 'white',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    py: '8px',
                                }}
                                type="submit"
                                variant="contained"
                                onClick={handleSubmit}
                            >
                                {translate('add_button')}
                            </Button>
                        </Grid2>
                    </Box>
                </form>
            )}
        />
    );
};

export default AddIncludesOptionForm;
